/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {
    SEARCH_LIST_INSERT,
    SEARCH_LAYER_TAB,
    SEARCH_WORD,
    SEARCH_WORD_HIGHLIGHT,
    SET_SEARCH_KEYWORD_ADV,
    SEARCH_POPULAR_LIST_INSERT, SEARCH_LAYER,
} from '../../libs/reducer';
import { setCookie } from 'basic/common/cookie';
import { uniqueArray } from '../../libs/util';
import SearchBar from './searchBar';
import DetailSearch from './detail_search';
import AutoFrame from './autoFrame';
import { ga4_AdClick } from 'common/libs/googleTagManager';
import { fixedEncodeURIComponent } from 'common/util/util';
import { useLocation } from "react-router";

const Search = ({ domain }) => {
    const { searchWordHighlight, searchLayerTab, searchList, searchLayerTabView, searchKeywordAdv } = useSelector(
        (state) => state.search,
    );

    const dispatch = useDispatch();
    const match = useRouteMatch();
    const { search } = useLocation();

    useEffect(() => {
        getUrlKeyword(); // 접속시 검색창에 검색어세팅
        advKeyword(); // 키워드광고api
        getRank(); // 인기검색어api
    }, []);

    useEffect(() => {
        if (searchWordHighlight?.length > 0) {
            if (searchLayerTab !== 'auto') {
                dispatch({
                    type: SEARCH_LAYER_TAB,
                    data: 'auto',
                });
            }
        } else {
            dispatch({
                type: SEARCH_LAYER_TAB,
                data: 'latest',
            });
        }
    }, [searchWordHighlight]);

    useEffect(() => {
        if(search.includes("ad_code")) {
            let queryStringAdCode = new URLSearchParams(search).get('ad_code');
            if(queryStringAdCode ==='dap022') {
                setTimeout(() => {
                    const searchBar = document.querySelector('.search_input');
                    searchBar.focus();
                    dispatch({
                        type: SEARCH_LAYER,
                        data: true,
                    });
                },1000)
            }
        }
    },[search])

    const onSearch = useCallback(
        (word, onSearchTextAdvLink) => {
            if (onSearchTextAdvLink && word === '') {
                // 광고문구 있으면
                // const { nm_ad, code_ad, idx_b_manager, ad_id, mall_name } = searchKeywordAdv

                // 검색광고 클릭 태그
                ga4_AdClick(searchKeywordAdv);
                // ua_AdClick(searchKeywordAdv);
                // uaEventClick(
                //     mall_name + '_' + idx_b_manager,
                //     nm_ad,
                //     ad_id,
                //     'null_null',
                // )
                // // gaEvent({
                // //     type: 'click',
                // //     event_category: `${code_ad}_${nm_ad}`,
                // //     event_label: ad_id,
                // //     value: 1,
                // //     idx_b_manager
                // // })
                window.location.href = onSearchTextAdvLink;
                return;
            }
            // gaEvent({
            //     type: 'click',
            //     event_category: '통합검색_검색어',
            //     event_label: word.trim(),
            //     value: 1,
            // })

            const date = new Date();
            const list = [...searchList];
            const newData = {
                id: Date.now(),
                s: word.trim(),
                d: moment(date).format('MM.DD'),
            };
            const clearList = list.map((v) => ({ id: v.id, s: v.s, d: v.d }));
            const newList = [newData, ...clearList];

            // 중복제거 && 리스트 10개 제한
            const uniqueList = uniqueArray(newList.slice(0, 10), 's');

            // 검색어저장
            if (word.trim() !== '' && searchLayerTabView.latest) {
                // 검색어가있고 검색어저장 기능이 켜져있을때
                setCookie(
                    'searchList',
                    JSON.stringify(uniqueList),
                    30 * 24 * 60 * 60,
                    '/',
                    `.pping.${process.env.REACT_APP_TLD}`,
                );
                dispatch({
                    type: SEARCH_LIST_INSERT,
                    data: uniqueList,
                });
            }

            // route
            if (domain === 'search') {
                // 리액트인스턴스 다른 이슈로 이벤트만 던져주고 라우트는 search.pping.kr 에서 처리
                // history.push(`/all/${word}`)
                const detail = { word };

                window.dispatchEvent(new CustomEvent('onSearch', { detail }));
            } else {
                window.location.href = `${process.env.REACT_APP_SEARCH_URL}/all/${fixedEncodeURIComponent(word)}`;
            }

            // moveTop
            window.scrollTo(0, 0);
        },
        [searchList, searchLayerTabView.latest, searchKeywordAdv],
    );

    const getUrlKeyword = () => {
        const keyword = match.params.keyword || '';

        dispatch({
            type: SEARCH_WORD,
            data: keyword,
        });
        dispatch({
            type: SEARCH_WORD_HIGHLIGHT,
            data: keyword,
        });
        dispatch({
            type: SEARCH_LAYER_TAB,
            data: 'auto',
        });
    };

    const advKeyword = async () => {
        const url = `${process.env.REACT_APP_API_URL}/front/v2/ads/PAG002`;
        try {
            const data = await axios.get(url);
            dispatch({
                type: SET_SEARCH_KEYWORD_ADV,
                data: data.data.result,
            });
        } catch (e) {
            console.log(e);
        }
    };

    const getRank = async () => {
        const url = `${process.env.REACT_APP_API_URL}/front/v3/search/ranking`;
        try {
            const data = await axios.get(url);
            dispatch({
                type: SEARCH_POPULAR_LIST_INSERT,
                data: data.data?.result?.result || [],
            });
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className="header_search_layout">
            <SearchBar onSearch={onSearch} />
            <DetailSearch onSearch={onSearch} />
            <AutoFrame onSearch={onSearch} />
        </div>
    );
};

export default Search;



// WEBPACK FOOTER //
// ./src/header/component/search/index.js